<div class="layout"
     [ngClass]="[
       'l-' + leftSideMode,
       'r-' + rightSideMode
     ]">

  <aside class="side">
    <section class="panel left-panel" [ngClass]="'w-' + leftSideMode">
      <left-panel [hidden]="leftSideMode === 'hidden'"></left-panel>
    </section>

    <section class="panel right-panel" [ngClass]="'w-' + rightSideMode">
      <right-panel [hidden]="rightSideMode === 'hidden'"></right-panel>
    </section>
  </aside>

  <div class="main">
    <world></world>
  </div>

</div>
